module.exports = __webpack_public_path__ + "static/media/avoid_interference.e2120c79.png";